import { Box } from "@mui/material";

import Text from "../Text/Text";

interface Props {
  text: string;
  isActive?: boolean;
  className?: string;
}

const Chip = ({ text, isActive, className }: Props) => {
  return (
    <Box className={`Chip ${isActive ? "isChipActive" : ""} ${className ?? ""}`}>
      <Text children={text} />
    </Box>
  );
};

export default Chip;